import { Flex, Skeleton } from '@iheartjane/reefer';

export function PriceSkeleton() {
  return (
    <Skeleton animate>
      <Flex ml="auto">
        <Skeleton.Bone height={24} width={72} />
      </Flex>
    </Skeleton>
  );
}
